import $ from "jquery";
import slick from "slick-carousel";
import anime from "animejs/lib/anime.es.js";

let cursorIsLeftMode = false;
if (document.querySelectorAll(".image-gallery").length) carouselKeyPress();
document
  .querySelectorAll(".image-gallery-revealer")
  .forEach((carouselElement) => {
    const sliderElem = carouselElement.querySelector(".image-gallery-slick");
    const heroImages = carouselElement.querySelectorAll(".hero-image");
    $(sliderElem).slick({
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: "linear",
      arrows: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });

    //if (heroImages.length > 1) {
    //    carouselElement.classList.add('image-gallery--arrow-visible')
    //    setupMouseFollow(carouselElement);
    //}

    // Detect if element is in the viewport to animate the arrows
    if (!window.IntersectionObserver) return;
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            carouselElement.classList.add("is-in-view");
          } else {
            carouselElement.classList.remove("is-in-view");
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(carouselElement);
  });

$(".image-gallery").on("click", function (event) {
  const arrow = event.currentTarget.querySelector(".slick-prev");
  if (arrow) arrow.focus();
});

function carouselKeyPress() {
  if (document.activeElement === ".image-gallery") {
    document.addEventListener("keydown", (event) => {
      switch (event.key) {
        case "ArrowLeft":
          carouselNavigate(".slick-prev");
          break;
        case "ArrowRight":
          carouselNavigate(".slick-next");
          break;
      }
    });
  }
}

function carouselNavigate(arrowClass) {
  let heroGallaries = document.querySelectorAll(".image-gallery");

  if (heroGallaries.length > 0) {
    heroGallaries.forEach(function (gallery, index) {
      if (isInViewport(gallery)) {
        const arrowToSelect = gallery.querySelector(arrowClass);
        if (arrowToSelect) arrowToSelect.click();
      }
    });
  }
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

//function setupMouseFollow(carouselElement) {
//    if (!carouselElement) {
//        console.warn("No image gallery found");
//        return;
//    }

//    const carouselBounds = carouselElement.getBoundingClientRect();
//    const carouselWidth = carouselBounds.width;
//    const arrow = carouselElement.querySelector('.image-gallery__arrow');
//    const arrowXHalf = arrow.offsetWidth / 2;
//    const arrowYHalf = arrow.offsetHeight / 2;

//    const carouselOffset = {
//        top: carouselBounds.top + window.scrollY,
//        left: carouselBounds.left + window.scrollX,
//    };

//    anime({
//        targets: arrow,
//        opacity: 0,
//        duration: 300,
//    });

//    carouselElement.addEventListener('pointerenter', (event) => {
//        updateArrowPosition(event);
//        anime({
//            targets: arrow,
//            opacity: 1,
//            duration: 300,
//        });
//    }, true);

//    carouselElement.addEventListener('pointerleave', (event) => {
//        updateArrowPosition(event);
//        anime({
//            targets: arrow,
//            opacity: 0,
//            duration: 300,
//        });
//    }, true);

//    carouselElement.addEventListener('pointermove', (event) => {
//        updateArrowPosition(event);
//    }, true);

//    carouselElement.addEventListener('mousedown', (event) => {
//        if (cursorIsLeftMode) {
//           $(carouselElement.querySelector('.image-gallery-slick')).slick("slickPrev");
//        } else {
//            $(carouselElement.querySelector('.image-gallery-slick')).slick("slickNext");
//        }
//    }, true);

//    function updateArrowPosition(event) {
//        const currentScrollPos = window['scrolInstance'].scroll.instance.scroll.y || 0;
//        const x = event.pageX - carouselOffset.left - arrowXHalf;
//        const pageOffsetTop = document.querySelector('#main').offsetTop;
//        const pageY = event.pageY;
//        const galleryOffsetTop = carouselElement.offsetTop;
//        const y = pageY - galleryOffsetTop + currentScrollPos - pageOffsetTop - arrowYHalf;

//        //const pageHeight = document.querySelector('#main').clientHeight;

//        cursorIsLeftMode = (x < carouselWidth / 2);

//        if (cursorIsLeftMode) {
//            arrow.classList.add("left")
//            arrow.classList.remove("right")
//        } else {
//            arrow.classList.add("right")
//            arrow.classList.remove("left")
//        }

//        anime({
//            targets: arrow,
//            translateX: x,
//            translateY: y,
//            scale: 1,
//            duration: 300,
//        });
//    }
//}
